import { render, staticRenderFns } from "./introduction.vue?vue&type=template&id=bc73e428&scoped=true&"
import script from "./introduction.vue?vue&type=script&lang=js&"
export * from "./introduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc73e428",
  null
  
)

export default component.exports